import React from 'react';
import { Container } from 'react-bootstrap';

const Register = () => {
    return (
        <Container className="py-5">
            <h2>Join LBO</h2>
            <p>Registration form coming soon...</p>
        </Container>
    );
};

export default Register;
